/**
 * Inline SVG hero graphic for the Private Broker Network page.
 * Warehouse → broker nodes → truck, connected by dashed lines.
 * Uses brand teal via currentColor. No external assets.
 */
export function PrivateBrokerNetworkHero({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 420 180"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      fill="none"
    >
      {/* Soft mint backdrop blob */}
      <circle cx="330" cy="70" r="120" className="fill-brand-teal/[0.06]" />
      <circle cx="90" cy="130" r="70" className="fill-brand-teal/[0.04]" />

      {/* Dashed connectors */}
      <g className="stroke-brand-teal/50" strokeWidth="1.5" strokeDasharray="4 4" strokeLinecap="round">
        <path d="M78 92 L170 60" />
        <path d="M78 92 L170 120" />
        <path d="M78 92 L170 92" />
        <path d="M195 60 L285 92" />
        <path d="M195 120 L285 92" />
        <path d="M195 92 L285 92" />
        <path d="M310 92 L370 92" />
      </g>

      {/* Warehouse (shipper) */}
      <g transform="translate(40 60)">
        <rect x="0" y="14" width="60" height="42" rx="3" className="fill-white stroke-brand-teal" strokeWidth="1.75" />
        <path d="M0 14 L30 0 L60 14 Z" className="fill-brand-teal/15 stroke-brand-teal" strokeWidth="1.75" strokeLinejoin="round" />
        <rect x="22" y="30" width="16" height="26" className="fill-brand-teal/20 stroke-brand-teal" strokeWidth="1.5" />
      </g>

      {/* Broker nodes */}
      {[
        { x: 170, y: 60 },
        { x: 170, y: 92 },
        { x: 170, y: 120 },
      ].map((p) => (
        <g key={`b1-${p.x}-${p.y}`} transform={`translate(${p.x - 12} ${p.y - 12})`}>
          <path
            d="M12 0 C6 0 2 4 2 10 C2 15 6 19 12 19 C18 19 22 15 22 10 C22 4 18 0 12 0 Z M12 22 C4 22 0 27 0 32 L24 32 C24 27 20 22 12 22 Z"
            className="fill-brand-teal/15 stroke-brand-teal"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </g>
      ))}

      {/* Middle hub node */}
      <g transform="translate(275 82)">
        <circle cx="10" cy="10" r="9" className="fill-brand-teal stroke-brand-teal" strokeWidth="1.5" />
        <circle cx="10" cy="10" r="4" className="fill-white" />
      </g>

      {/* Truck (carrier delivery) */}
      <g transform="translate(360 70)">
        <rect x="0" y="6" width="28" height="22" rx="2" className="fill-white stroke-brand-teal" strokeWidth="1.75" />
        <path d="M28 14 L42 14 L48 22 L48 28 L28 28 Z" className="fill-brand-teal/15 stroke-brand-teal" strokeWidth="1.75" strokeLinejoin="round" />
        <circle cx="10" cy="30" r="4" className="fill-white stroke-brand-teal" strokeWidth="1.75" />
        <circle cx="38" cy="30" r="4" className="fill-white stroke-brand-teal" strokeWidth="1.75" />
      </g>
    </svg>
  );
}

export default PrivateBrokerNetworkHero;
